import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { normalize } from 'normalizr';
import * as Schema from 'catalog/api/schema';
import * as Api from 'catalog/api/deployments';
import { getIsFetched } from 'catalog/reducers/deployments';
import { displayJsonError } from 'utils/errors';
import {
  FETCH_DEPLOYMENTS,
  FETCH_DEPLOYMENTS_SUCCESS,
  FETCH_DEPLOYMENTS_FAILURE,
  DEPLOY,
  DEPLOY_SUCCESS,
  DEPLOY_FAILURE,
} from 'catalog/actions/deployments';

function* fetchDeployments() {
  const isFetched = yield select(getIsFetched);

  if (isFetched) return;

  try {
    const result = yield call(Api.fetch);
    yield put({
      type: FETCH_DEPLOYMENTS_SUCCESS,
      response: normalize(result, Schema.deployments),
    });
  } catch (error) {
    yield put({
      type: FETCH_DEPLOYMENTS_FAILURE,
      error: displayJsonError(error),
    });
  }
}

function* deploy() {
  // Make animaton smoother
  yield delay(500);

  try {
    const result = yield call(Api.deploy);
    yield put({
      type: DEPLOY_SUCCESS,
      response: normalize(result, Schema.deployment),
    });
  } catch (error) {
    yield put({
      type: DEPLOY_FAILURE,
      error: displayJsonError(error),
    });
  }
}

export default function* root() {
  yield [
    takeLatest(FETCH_DEPLOYMENTS, fetchDeployments),
    takeEvery(DEPLOY, deploy),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/catalog/sagas/deployments.js